import * as React from 'react';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Dispatch, connect } from 'react-redux';
import { IApplicationState, AppActionCreators, DashCenterActionCreators, ICenterDashDetailResponse, IDashCenterLookupDataResponse, IDashLogListResponse, IExpertSystemEnrollResponse, ICheckDonorProfileResponse, IRecipientCoordListLookupDataResponse, DonorShieldDirectActionCreators, DonorSearchActionCreators } from '@nkr/store/index';
import { IDonorRegistration, IBaseResponse, IDonorDetailsRequest, IListItem, IDonorStatus, IDonorConnectEmailRequest, IContact, IDonorStatusByCenter, ICoordinatorListByCenter } from '@nkr/models/index';
import { IDashWorkFlowStatusRequest } from '@nkr/models/dash-workflow-status-request';
import { DashRegistrationStep } from '@nkr/enums/dash-registration-step';
import { DashDonationType } from '@nkr/enums/index';
import { ICoordinator } from '../../coordinator';
import { toast } from 'react-toastify';
import { AxiosError } from 'axios';
import { downloadFile } from '@nkr/services/download-file';
import Content from './content';
import DonorConnectEmailConfirmation from '@nkr/views/dash/donor-connect/donor-connect-email-confirmation';
import MarkJugArrivedSendEmail from '../all/mark-jug-arrived-send-email';
import ExpertSystemEnrollmentConfirm from '../expert-system-enrollment-confirm';
import ExpertSystemEnrollmentResponse from '../expert-system-enrollment-response';
import RuleOut from './rule-out';
import ReverseRuleOut from './reverse-rule-out';
import RecipientCenterCoordinatorConfirm from '../recipient-center-coordinator-confirm';
import ExpireDonorModal from '../../pwl/expire-donor-modal';
import OptOutDonorModal from '../../pwl/opt-out-donor-modal';
import DonorShieldInviteSentModal from '../donor-shield-invite-sent-modal';
import AdvancedReimbursementWorkupModal, { IAdvancedReimbursementSubmittedForm } from '../advanced-reimbursement-workup-modal';
import AdvancedReimbursementEnrolledScheduleModal from '../advanced-reimbursement-enrolled-schedule-modal';
import {
    advancedReimbursementNetworkPromptSnapshot,
    buildAdvancedReimbursementNetworkExtras,
    IAdvancedReimbursementNetworkPayload,
    isAdvancedReimbursementInviteFlowApplicable,
    isEligibleForAdvancedReimbursementInvite,
    isEnrolledInAdvancedReimbursement,
    isPreOpScheduledWithFutureDate,
    isWorkupScheduledWithFutureDate,
    PRE_OP_SCHEDULED_REMOTE_STATUS_ID,
    shouldPromptAdvancedReimbursementEnrolledScheduleModal,
    shouldPromptAdvancedReimbursementNetworkModal,
    WORKUP_SCHEDULED_REMOTE_STATUS_ID
} from '../advanced-reimbursement-workflow';
import { DonorIntakeAction } from '../donor-intake-action';
import { IDashRemoteStatus } from '@nkr/models/donor-status-by-center';
import {
    IDonorShieldInviteOutcome,
    donorShieldInviteNotSentMessage,
    shouldWarnDonorShieldInviteNotSent
} from '../donor-shield-invite-outcome';

interface IOwnProps {
    centerId: number,
    regId: number,
    isSuperAdmin: boolean
}

interface IStateProps { }

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getDonorDetails: (centerId: number, registrationId: number) => Promise<ICenterDashDetailResponse>,
    donorDetailsPrint: (centerId: number, registrationId: number) => Promise<any>,
    handleLoginAs: (registrationId: number) => Promise<any>,
    updateDetails: (centerId: number, regId: number, wfStatusId: number, centerNextFollowUpDate: string, remoteStatus: number, onHoldStatusReason: string, remoteStatusDate: string, reviewComments: string) => Promise<IBaseResponse>
    changeStatus: (request: IDashWorkFlowStatusRequest) => Promise<IBaseResponse>,
    updateDonorRegistrationWorkflowStatus: (centerId: number, regId: number, statusId: number, centerNextFollowUpDate: string) => Promise<IBaseResponse>,
    updateDonorRegistrationNetworkStatus: (
        centerId: number,
        regId: number,
        remoteStatus: number | null,
        remoteStatusDate: string | null,
        onHoldStatusReason: string | null,
        extras?: IAdvancedReimbursementNetworkPayload | null
    ) => Promise<IBaseResponse>,
    searchArPerson: (centerId: number, firstName: string, lastName: string, birthDate: string, organType: number) => Promise<any>,
    searchArAliases: (centerId: number, donorAlias: string, recipientAlias: string, organType: number) => Promise<any>,
    searchArDonorPerson: (centerId: number, firstName: string, lastName: string, birthDate: string) => Promise<any>,
    getDashCenterLookupData: (centerId: number, isSuper: boolean) => Promise<IDashCenterLookupDataResponse>,
    getDonorCenterLogEntries: (centerId: number, regId: number, isAdmin: boolean) => Promise<IDashLogListResponse>,
    updateComments: (id: number, detailRequest: IDonorDetailsRequest) => Promise<IBaseResponse>,
    updateDisposition: (id: number, detailRequest: IDonorDetailsRequest) => Promise<IBaseResponse>,
    changeAssignedCoordinator: (centerId: number, regId: number, contactId: number) => Promise<IBaseResponse>,
    unassignCoordinator: (centerId: number, regId: number) => Promise<IBaseResponse>,
    saveLogEntry: (centerId: number, dashRegistrationId: number, actionTaken: number, comments: string) => Promise<ICenterDashDetailResponse>,
    updateLogEntry: (id: number, centerId: number, dashRegistrationId: number, actionTaken: number, comments: string) => Promise<ICenterDashDetailResponse>,
    deleteLogEntry: (centerId: number, dashRegistrationId: number, id: number,) => Promise<ICenterDashDetailResponse>,
    updateNextFollowUpDate: (centerId: number, registrationId: number, date: string) => Promise<IBaseResponse>,
    updateDonorDetails: (id: number, detailRequest: IDonorDetailsRequest) => Promise<IBaseResponse>,
    enrollExpertSystem: (registrationId: number, bulkType: number, alias: string, medicalRecordId: number) => Promise<IExpertSystemEnrollResponse>,
    checkDonorProfile: (registrationId: number) => Promise<ICheckDonorProfileResponse>,
    getLabResultsNotCombined: (registrationId: number) => Promise<any>,
    getLabResultsCombined: (registrationId: number) => Promise<any>,
    sendConfirmEmail: (request: IDonorConnectEmailRequest) => Promise<IBaseResponse>,
    markJugAsArrived: (donorId: number, arrivalDate: string) => Promise<IBaseResponse>,
    ruleOut: (registrationId: number, isExpireRuleOut: boolean, isInEmr: boolean, disposition: number, ruleOutReasons: string) => Promise<ICenterDashDetailResponse>,
    reverseRuleOut: (registrationId: number) => Promise<ICenterDashDetailResponse>,
    validateExpertSystemEnrollment: (registrationId: number, alias: string) => Promise<IBaseResponse>
    getRecipientCenterCoordList: (centerId: number) => Promise<IRecipientCoordListLookupDataResponse>,
    updateRecipientCenterCoord: (centerId: number, donorId: number, coordinatorId: number) => Promise<IBaseResponse>,
    getLabOrder: (registrationId: number) => Promise<any>,
    expireDonor: (registrationId: number, centerId: number) => Promise<ICenterDashDetailResponse>,
    optOutDonor: (registrationId: number, centerId: number) => Promise<ICenterDashDetailResponse>,
}

type TProps =
    IOwnProps
    & IStateProps
    & IDispatchProps;

interface IState {
    centerId: number,
    donorRegistration: IDonorRegistration,
    lookUpData: {
        emailTemplate: string,
        remoteStatusList: IDashRemoteStatus[],
        statusListByCenter: IDonorStatusByCenter[],
        statusListForCenter: IDonorStatus[],
        donationTypeList: IListItem[],
        actionList: IListItem[],
        dispositionList: IListItem[],
        coordinatorListByCenter: ICoordinatorListByCenter[],
        coordinatorListForCenter: ICoordinator[],
        ruleOutReasons: IListItem[]
    },
    mentorConfirmView: {
        show: boolean,
        data: IDonorRegistration
    },
    confirmView: {
        show: boolean,
        formData: IDonorRegistration,
        jugArrivalDate: string
    },
    confirmRecipientCoordinator: {
        show: boolean,
        formData: IDonorRegistration,
        alias: string
    },
    confirmExpertSystemEnrollment: {
        show: boolean,
        formData: IDonorRegistration,
        error: string,
        existingDonorAlias: string | null
    },
    confirmExpertSystemResponse: {
        show: boolean,
        donorId: number,
        useBulkKit: number,
        existingTyping: boolean,
        existingRequestForTyping: boolean,
        existingSwabMessage?: string,
        alias: string
    },
    confirmTransferDonor: {
        show: boolean,
        formData: IDonorRegistration,
        coordinatorList: IContact[],
        coordinatorId: number
    },
    validation: {
        centerWorkFlowIdValid: boolean,
        centerNextFollowupDateValid: boolean
    },
    recipientCenterCoordValidation: {
        coordinatorIdValid: boolean
    },
    ruleOut: {
        show: boolean,
        data: IDonorRegistration,
    },
    expireDonor: {
        show: boolean,
        data: IDonorRegistration
    },
    optOutDonor: {
        show: boolean,
        data: IDonorRegistration
    },
    reverseRuleOut: {
        show: boolean,
        data: IDonorRegistration,
    },
    donorShieldInviteSent: {
        show: boolean,
        donorName: string
    },
    advancedReimbursementWorkupModalOpen: boolean,
    advancedReimbursementEnrolledScheduleModalOpen: boolean,
    arDeclinedNetworkSnapshot: string | null,
    statusFormBaselineKey: number
}

class DonorDetails extends React.Component<TProps, IState> {
    private persistedCoordinatorId: number | null = null;

    readonly state: IState = {
        centerId: 0,
        donorRegistration: null,
        lookUpData: {
            emailTemplate: '',
            statusListByCenter: [],
            remoteStatusList: [],
            statusListForCenter: [],
            donationTypeList: [],
            actionList: [],
            dispositionList: [],
            coordinatorListByCenter: [],
            coordinatorListForCenter: [],
            ruleOutReasons: []
        },
        confirmView: {
            show: false,
            formData: null,
            jugArrivalDate: null
        },
        mentorConfirmView: {
            show: false,
            data: null
        },
        confirmRecipientCoordinator: {
            show: false,
            formData: null,
            alias: ''
        },
        confirmExpertSystemEnrollment: {
            show: false,
            formData: null,
            error: '',
            existingDonorAlias: null
        },
        confirmExpertSystemResponse: {
            show: false,
            donorId: -1,
            useBulkKit: -1,
            existingTyping: false,
            existingRequestForTyping: false,
            alias: ''
        },
        confirmTransferDonor: {
            show: false,
            formData: null,
            coordinatorList: null,
            coordinatorId: -1
        },
        validation: {
            centerWorkFlowIdValid: true,
            centerNextFollowupDateValid: true
        },
        recipientCenterCoordValidation: {
            coordinatorIdValid: true
        },
        ruleOut: {
            show: false,
            data: null
        },
        expireDonor: {
            show: false,
            data: null
        },
        optOutDonor: {
            show: false,
            data: null
        },
        reverseRuleOut: {
            show: false,
            data: null
        },
        donorShieldInviteSent: {
            show: false,
            donorName: ''
        },
        advancedReimbursementWorkupModalOpen: false,
        advancedReimbursementEnrolledScheduleModalOpen: false,
        arDeclinedNetworkSnapshot: null,
        statusFormBaselineKey: 0
    }

    intervalId: any;

    componentDidMount() {
        this.getDonorDetailsData();
    }

    private shouldShowDonorShieldInviteFromQuery = () => {
        const searchParams = new URLSearchParams(window.location.search || '');
        return searchParams.get('dsInvite') === '1';
    }

    getDonorDetailsData = () => {
        this.props.showLoading('Loading Donor Details, one moment please...').then(() => {
            Promise.all([
                this.props.getDonorDetails(this.props.centerId, this.props.regId),
                this.props.getDashCenterLookupData(this.props.centerId, this.props.isSuperAdmin)
            ]).then(([donorDetailsResponse, lookUpResponse]) => {
                let { statusListByCenter, remoteStatusList, actionList, dispositionList, donationTypeList, coordinatorListByCenter, emailTemplate, ruleOutReasons } = lookUpResponse.data.results;
                let coordinatorListForCenter = coordinatorListByCenter.flatMap(x => x.list);
                let statusListForCenter = this.props.centerId > 0 ? statusListByCenter.find(x => x.centerId == this.props.centerId).listItems : [];
                this.setState({
                    donorRegistration: donorDetailsResponse.data.results,
                    lookUpData: {
                        emailTemplate,
                        statusListByCenter,
                        statusListForCenter,
                        donationTypeList,
                        remoteStatusList,
                        actionList,
                        dispositionList,
                        coordinatorListByCenter,
                        coordinatorListForCenter,
                        ruleOutReasons
                    }
                }, () => {
                    this.persistedCoordinatorId = Number(donorDetailsResponse.data.results?.coordinatorId ?? 0);
                    if (this.shouldShowDonorShieldInviteFromQuery() && isEligibleForAdvancedReimbursementInvite(this.state.donorRegistration)) {
                        let data = _.cloneDeep(this.state.donorRegistration);
                        data['donorShieldInvitePendingWorkup'] = true;
                        this.setState({ donorRegistration: data });
                    }
                    this.props.hideLoading();
                });
            });
        });
    }
    validate = () => {
        let { centerNextFollowUpDate, centerWorkflowId } = this.state.donorRegistration;
        let requiresFollowUp = this.state.lookUpData.statusListForCenter.find(item => item.id == centerWorkflowId)?.requiresFollowUp;

        let centerWorkFlowIdValid = centerWorkflowId != -1;
        let centerNextFollowupDateValid = !requiresFollowUp || (centerNextFollowUpDate != null && centerNextFollowUpDate != '' && moment(centerNextFollowUpDate, 'MM/DD/YYYY', true).isValid());
        let coordinatorIdValid: true;

        return { centerWorkFlowIdValid, centerNextFollowupDateValid, coordinatorIdValid };
    }

    handleDataChange = (field: string, value: any) => {
        let data        = _.cloneDeep(this.state.donorRegistration);
        data[field]     = value;

        this.setState({
            donorRegistration: data
        });
    }

    refreshDonorRegistrationAfterStatusUpdate = async (): Promise<IDonorRegistration | null> => {
        try {
            const logResponse = await this.props.getDonorCenterLogEntries(this.props.centerId, this.props.regId, false);
            const donorResponse = await this.props.getDonorDetails(this.props.centerId, this.props.regId);
            if (!donorResponse?.data?.success) {
                return null;
            }
            const updated = _.cloneDeep(donorResponse.data.results) as IDonorRegistration;
            updated.logs = logResponse?.data?.results ?? updated.logs ?? [];
            this.persistedCoordinatorId = Number(updated.coordinatorId ?? 0);
            this.setState(prev => ({
                donorRegistration: updated,
                statusFormBaselineKey: prev.statusFormBaselineKey + 1
            }));
            return updated;
        } catch {
            return null;
        }
    };

    handleUpdate = (request?: IDashWorkFlowStatusRequest) => {
        const workupScheduledStatusId = 10;

        if (request) {
            
            const selectedStatus = this.state.lookUpData.statusListForCenter.find(s => s.id === request.statusId);            
            const isRuleOutStatus = selectedStatus && selectedStatus.isRuledOut === true;            
            const isAlreadyRuledOut = this.state.donorRegistration.currentRegistrationStep >= DashRegistrationStep.AutoRuledOut;

            if (isRuleOutStatus && !isAlreadyRuledOut && this.state.lookUpData.ruleOutReasons.length > 0) {
                
                return;
            }

            let data = _.cloneDeep(this.state.donorRegistration);
            data['centerWorkflowId'] = request.statusId;
            data['centerNextFollowUpDate'] = request.centerNextFollowUpDate;
            data['remoteStatus'] = request.remoteStatus;
            data['onHoldStatusReason'] = request.onHoldStatusReason;
            data['remoteStatusDate'] = request.remoteStatusDate;
            data['reviewComments'] = request.reviewComments;

            this.setState({
                donorRegistration: data
            });


            this.props.showLoading('Updated details, one moment please...').then(() => {
                this.props.updateDetails(this.props.centerId, this.props.regId, request.statusId, request.centerNextFollowUpDate, request.remoteStatus, request.onHoldStatusReason, request.remoteStatusDate, request.reviewComments)
                    .then(async response => {
                        if (response.data.success) {
                            const inviteOutcome = (response?.data?.results || {}) as IDonorShieldInviteOutcome;
                            const donorShieldInviteSucceeded = !!inviteOutcome.inviteSent;
                            const updatedData = await this.refreshDonorRegistrationAfterStatusUpdate();
                            if (!updatedData) {
                                toast.error('Status changed, but unable to refresh donor details.');
                                return;
                            }
                            if (donorShieldInviteSucceeded) {
                                this.setState({
                                    donorShieldInviteSent: {
                                        show: true,
                                        donorName: updatedData.fullName || ''
                                    }
                                });
                            }
                            if (shouldWarnDonorShieldInviteNotSent(inviteOutcome)) {
                                toast.warn(donorShieldInviteNotSentMessage(inviteOutcome));
                                return;
                            }
                            toast.success('Status changed successfully');
                        }
                    })
                    .catch((error: AxiosError | Error) => {
                        const errorMessage = (error as AxiosError)?.response?.data || error.message || 'Unable to update donor status.';
                        toast.error(errorMessage as string);
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        } else {

            let { centerWorkflowId, centerNextFollowUpDate, remoteStatus, onHoldStatusReason, remoteStatusDate, reviewComments } = this.state.donorRegistration;

            this.props.showLoading('Updated details, one moment please...').then(() => {
                this.props.updateDetails(this.props.centerId, this.props.regId, centerWorkflowId, centerNextFollowUpDate, remoteStatus, onHoldStatusReason, remoteStatusDate, reviewComments)
                    .then(async response => {
                        if (response.data.success) {
                            const inviteOutcome = (response?.data?.results || {}) as IDonorShieldInviteOutcome;
                            const data = await this.refreshDonorRegistrationAfterStatusUpdate();
                            if (!data) {
                                toast.error('Status changed, but unable to refresh donor details.');
                                return;
                            }
                            if (inviteOutcome.inviteSent) {
                                this.setState({
                                    donorShieldInviteSent: {
                                        show: true,
                                        donorName: data.fullName || ''
                                    }
                                });
                            }
                            if (shouldWarnDonorShieldInviteNotSent(inviteOutcome)) {
                                toast.warn(donorShieldInviteNotSentMessage(inviteOutcome));
                                return;
                            }
                            toast.success('Status changed successfully');
                        }
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        }
    }

    buildCommentUpdateRequest = (d: IDonorRegistration): IDonorDetailsRequest => ({
        id: d.id,
        disposition: '',
        dispositionId: 0,
        comments: d.reviewComments || '',
        closeLoopSurgeryDateTime: '',
        closeLoopEntityTypeId: 0,
        closeLoopEntityType: 0,
        firstName: '',
        lastName: '',
        birthDate: '',
        phoneNumber: '',
        email: '',
        addressLine1: '',
        donorCity: '',
        donorState: '',
        donorStateId: 0,
        donorPostalCode: ''
    });

    handleSaveCenterCard = async () => {
        const d = this.state.donorRegistration;
        const previousCoordinatorId = Number(this.persistedCoordinatorId ?? d.coordinatorId ?? 0);
        const nextCoordinatorId = Number(d.coordinatorId ?? 0);
        const selectedStatus = this.state.lookUpData.statusListForCenter.find(s => s.id === d.centerWorkflowId);
        const isRuleOutStatus = selectedStatus && selectedStatus.isRuledOut === true;
        const isAlreadyRuledOut = d.currentRegistrationStep >= DashRegistrationStep.AutoRuledOut;
        if (isRuleOutStatus && !isAlreadyRuledOut && this.state.lookUpData.ruleOutReasons.length > 0) {
            return;
        }
        await this.props.showLoading('Saving, one moment please...');
        try {
            if (nextCoordinatorId !== previousCoordinatorId) {
                const coordinatorResponse = nextCoordinatorId > 0
                    ? await this.props.changeAssignedCoordinator(this.props.centerId, this.props.regId, nextCoordinatorId)
                    : await this.props.unassignCoordinator(this.props.centerId, this.props.regId);
                if (!coordinatorResponse?.data?.success) {
                    toast.error('Coordinator update failed');
                    return;
                }
                this.persistedCoordinatorId = nextCoordinatorId;
            }
            const wf = await this.props.updateDonorRegistrationWorkflowStatus(this.props.centerId, this.props.regId, d.centerWorkflowId ?? -1, d.centerNextFollowUpDate || '');
            if (!wf?.data?.success) {
                toast.error('Workflow update failed');
                return;
            }
            const cm = await this.props.updateComments(this.props.centerId, this.buildCommentUpdateRequest(d));
            if (!cm?.data?.success) {
                toast.error('Comments update failed');
                return;
            }
            const refreshed = await this.refreshDonorRegistrationAfterStatusUpdate();
            if (!refreshed) {
                toast.error('Saved, but unable to refresh donor details.');
                return;
            }
            toast.success('Saved');
        } catch {
            toast.error('Save failed');
        } finally {
            this.props.hideLoading();
        }
    };

    handleSaveNetworkCard = async () => {
        const d = this.state.donorRegistration;
        if (!d) {
            return;
        }
        if (shouldPromptAdvancedReimbursementNetworkModal(d, this.state.arDeclinedNetworkSnapshot)) {
            this.setState({ advancedReimbursementWorkupModalOpen: true });
            return;
        }
        if (shouldPromptAdvancedReimbursementEnrolledScheduleModal(d)) {
            this.setState({ advancedReimbursementEnrolledScheduleModalOpen: true });
            return;
        }
        await this.executeSaveNetworkCardWithExtras();
    };

    executeSaveNetworkCardWithExtras = async (
        inviteExplicit?: 'yes' | 'no',
        form?: IAdvancedReimbursementSubmittedForm | null
    ) => {
        const d = this.state.donorRegistration;
        if (!d) {
            return;
        }
        const extrasRaw = buildAdvancedReimbursementNetworkExtras(d, this.state.arDeclinedNetworkSnapshot, inviteExplicit, inviteExplicit === 'yes' ? form ?? undefined : undefined);
        const extrasPayload = Object.keys(extrasRaw).length ? extrasRaw : null;
        const applyFlag = extrasPayload?.applyForDonorShieldAdvancedReimbursement;
        const inviteFlowApplicable = isAdvancedReimbursementInviteFlowApplicable(d, applyFlag);

        await this.props.showLoading('Saving, one moment please...');
        try {
            const response = await this.props.updateDonorRegistrationNetworkStatus(
                this.props.centerId,
                this.props.regId,
                d.remoteStatus,
                d.remoteStatusDate || null,
                d.onHoldStatusReason || null,
                extrasPayload
            );
            if (!response?.data?.success) {
                toast.error('Network status update failed');
                return;
            }
            const inviteOutcome = (response?.data?.results || {}) as IDonorShieldInviteOutcome;
            const donorShieldInviteSucceeded = !!inviteOutcome.inviteSent;
            const preOpNoticeSent = !!inviteOutcome.preOpScheduledNoticeSent;
            const updated = await this.refreshDonorRegistrationAfterStatusUpdate();
            if (!updated) {
                toast.error('Saved, but unable to refresh donor details.');
                return;
            }
            this.setState(prev => ({
                advancedReimbursementWorkupModalOpen: false,
                advancedReimbursementEnrolledScheduleModalOpen: false,
                arDeclinedNetworkSnapshot: inviteFlowApplicable ? null : prev.arDeclinedNetworkSnapshot,
                donorShieldInviteSent: donorShieldInviteSucceeded
                    ? { show: true, donorName: updated.fullName || '' }
                    : prev.donorShieldInviteSent
            }));
            if (shouldWarnDonorShieldInviteNotSent(inviteOutcome, preOpNoticeSent)) {
                toast.warn(donorShieldInviteNotSentMessage(inviteOutcome));
            } else if (!donorShieldInviteSucceeded) {
                if (
                    isEnrolledInAdvancedReimbursement(d)
                    && isPreOpScheduledWithFutureDate(d)
                ) {
                    if (preOpNoticeSent) {
                        toast.success('Saved. Donor notified of scheduled pre-op appointment and next Advanced Reimbursement steps.');
                    } else {
                        toast.success('Saved. Pre-op appointment date confirmed.');
                    }
                } else if (
                    isEnrolledInAdvancedReimbursement(d)
                    && isWorkupScheduledWithFutureDate(d)
                ) {
                    toast.success('Saved. Workup appointment date confirmed.');
                } else {
                    toast.success('Saved');
                }
            }
        } catch {
            toast.error('Save failed');
        } finally {
            this.props.hideLoading();
        }
    };

    handleAdvancedReimbursementWorkupModalClose = () => {
        this.setState({ advancedReimbursementWorkupModalOpen: false });
    };

    mapArSearchHits = (results: any[]) => {
        return (results || []).map((x: any) => ({
            id: x.id,
            donorAlias: x.donorAlias,
            recipientAlias: x.recipientAlias,
            donorEmail: x.donorEmail,
            donorName: x.donorName,
            donorBirthDate: x.donorBirthDate,
            recipientFirstName: x.recipientFirstName,
            recipientLastName: x.recipientLastName,
            recipientBirthDate: x.recipientBirthDate,
            surgeryDate: x.surgeryDate,
            watrRequestId: x.watrRequestId,
            donorRegistrationId: x.donorRegistrationId
        }));
    };

    /** Liver AR: DonorShield Direct records only (OrganType.Liver). */
    handleArDsdPersonSearch = async (firstName: string, lastName: string, birthDate: string) => {
        const response = await this.props.searchArPerson(
            this.props.centerId,
            firstName,
            lastName,
            birthDate,
            DashDonationType.Liver
        );
        if (!response?.data?.success) {
            return [];
        }
        return this.mapArSearchHits(response.data.results || []);
    };

    /** Kidney AR: Donor table records only (not DSD). */
    handleArDonorPersonSearch = async (firstName: string, lastName: string, birthDate: string) => {
        const response = await this.props.searchArDonorPerson(
            this.props.centerId,
            firstName,
            lastName,
            birthDate
        );
        if (!response?.data?.success) {
            return [];
        }
        return this.mapArSearchHits(response.data.results || []);
    };

    /** Liver AR only: DSD alias lookup. */
    handleArAliasSearch = async (donorAlias: string, recipientAlias?: string) => {
        const response = await this.props.searchArAliases(
            this.props.centerId,
            donorAlias || '',
            recipientAlias || '',
            DashDonationType.Liver
        );
        if (!response?.data?.success) {
            return [];
        }
        return this.mapArSearchHits(response.data.results || []);
    };

    handleAdvancedReimbursementEnrolledScheduleModalClose = () => {
        this.setState({ advancedReimbursementEnrolledScheduleModalOpen: false });
    };

    handleAdvancedReimbursementEnrolledScheduleConfirm = () => {
        this.setState({ advancedReimbursementEnrolledScheduleModalOpen: false }, () => {
            void this.executeSaveNetworkCardWithExtras();
        });
    };

    handleAdvancedReimbursementSaveWorkupOnly = () => {
        const d = this.state.donorRegistration;
        if (!d) {
            return;
        }
        this.setState({
            advancedReimbursementWorkupModalOpen: false,
            arDeclinedNetworkSnapshot: advancedReimbursementNetworkPromptSnapshot(d)
        }, () => void this.executeSaveNetworkCardWithExtras('no', null));
    };

    handleAdvancedReimbursementSubmitApply = (form: IAdvancedReimbursementSubmittedForm) => {
        this.setState(prev => {
            const merged = _.cloneDeep(prev.donorRegistration!);
            if (form.ddRecipFirstName != null) merged.recipFirstName = form.ddRecipFirstName;
            if (form.ddRecipLastName != null) merged.recipLastName = form.ddRecipLastName;
            if (form.ddRecipDob != null) merged.recipDob = form.ddRecipDob;
            merged.donorShieldInvitePendingWorkup = true;
            return {
                donorRegistration: merged,
                advancedReimbursementWorkupModalOpen: false,
                arDeclinedNetworkSnapshot: null
            };
        }, () => void this.executeSaveNetworkCardWithExtras('yes', form));
    };

    handleStatusFormRuleOut = (donorId: number, reasonId: number, allowReRegistration: boolean, useNkrAssistance: boolean, coordinatorName?: string, phoneNumber?: string, medicalReasonCategory?: number, medicalReasonNotes?: string) => {

        if (reasonId < 1 || reasonId > 3) {
            toast.error('Invalid rule-out reason selected');
            return;
        }

        const ruleOutData = {
            ruleOutReasonId: reasonId.toString(),
            allowReRegistration: allowReRegistration,
            useNkrAssistance: useNkrAssistance,
            coordinatorName: coordinatorName || '',
            phoneNumber: phoneNumber || '',
            medicalReasonCategory: medicalReasonCategory,
            medicalReasonNotes: medicalReasonNotes
        };

        this.props.showLoading('Updating record, one moment please...').then(() => {

            const request: IDashWorkFlowStatusRequest = {
                centerId: this.props.centerId,
                registrationId: donorId,
                statusId: -1,
                centerNextFollowUpDate: null,
                reviewComments: null,
                remoteStatus: null,
                onHoldStatusReason: null,
                remoteStatusDate: null,
                ruleOutReasonId: ruleOutData.ruleOutReasonId,
                allowReRegistration: ruleOutData.allowReRegistration,
                useNkrAssistance: ruleOutData.useNkrAssistance,
                coordinatorName: ruleOutData.coordinatorName,
                phoneNumber: ruleOutData.phoneNumber,
                medicalReasonCategory: ruleOutData.medicalReasonCategory,
                medicalReasonNotes: ruleOutData.medicalReasonNotes
            };

            this.props.changeStatus(request)
                .then(response => {
                    if (response.data.success) {
                        return this.props.getDonorDetails(this.props.centerId, donorId);
                    } else {
                        throw new Error('Failed to update status');
                    }
                })
                .then(donorResponse => {
                    if (donorResponse.data.success) {
                        this.setState({
                            donorRegistration: donorResponse.data.results
                        }, () => {
                            this.persistedCoordinatorId = Number(donorResponse.data.results?.coordinatorId ?? 0);
                            toast.success('Rule out successful.');
                        });
                    } else {
                        toast.error('Unable to rule out the donor');
                    }
                })
                .catch((error) => {
                    console.error('Rule out error:', error);
                    toast.error('Unable to rule out the donor');
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleAssignedCoordinatorChange = (regId: number, contactId: number) => {
        if (contactId > 0) {
            this.props.showLoading('Changing assigned coordinator, one moment please...').then(() => {
                this.props.changeAssignedCoordinator(this.props.centerId, regId, contactId).then(async response => {
                    this.props.hideLoading();

                    if (response.data.success) {
                        var logResponse = await this.props.getDonorCenterLogEntries(this.props.centerId, regId, this.props.isSuperAdmin);

                        let data = _.cloneDeep(this.state.donorRegistration)
                        let contact = this.state.lookUpData.coordinatorListForCenter.find(x => x.contactId == contactId);

                        var coordinatorListByCenter = _.cloneDeep(this.state.lookUpData.coordinatorListByCenter).map(item => {
                            item.list = item.list.map(co => {
                                if (co.contactId == contactId) {
                                    co.activeCaseCount++;
                                    co.totalCaseCount++;
                                } else if (co.id == data.coordinatorId) {
                                    co.activeCaseCount--;
                                    co.totalCaseCount--;
                                }

                                return co;
                            });

                            return item;
                        });

                        data['coordinatorId'] = contactId;
                        data['coordinator'] = { id: contact.contactId, fullName: contact.fullName };
                        data['logs'] = logResponse.data.results;

                        this.setState({
                            lookUpData: { ...this.state.lookUpData, coordinatorListByCenter },
                            donorRegistration: data
                        }, () => {
                            toast.success('Status changed successfully');
                        });
                    }
                });
            });
        } else {
            this.props.showLoading('Unassigning coordinator, one moment please...').then(() => {
                this.props.unassignCoordinator(this.props.centerId, regId)
                    .then(async response => {
                        if (response.data.success) {
                            let logResponse = await this.props.getDonorCenterLogEntries(this.props.centerId, regId, this.props.isSuperAdmin);

                            let data = _.cloneDeep(this.state.donorRegistration)

                            data['coordinatorId'] = 0;
                            data['coordinator'] = null;
                            data['logs'] = logResponse.data.results;

                            this.setState({
                                donorRegistration: data
                            }, () => {
                                toast.success('Status changed successfully');
                            });
                            toast.success('Coordinator unassigned successfully');
                        }
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        }
    }

    handleNextFollowUpDateChange = (date: string) => {
        let data = _.cloneDeep(this.state.donorRegistration)
        data.centerNextFollowUpDate = date;

        this.setState({
            donorRegistration: data
        });
    }

    handleRemoveNextFollowUpDate = (id: number) => {
        let data = _.cloneDeep(this.state.donorRegistration);
        data.centerNextFollowUpDate = '';

        this.setState({
            donorRegistration: data
        }, () => {
            this.removeNextFollowUpDate(id);
        });
    }

    handleUpdateNextFollowUpDate = (id: number) => {
        let { centerNextFollowUpDate } = this.state.donorRegistration;
        this.updateNextFollowUpDate(id, centerNextFollowUpDate);
    }

    removeNextFollowUpDate = (id: number) => {
        this.props.showLoading('Removing next follow-up date, one moment please...').then(() => {
            this.props.updateNextFollowUpDate(this.props.centerId, id, '').then(async response => {
                this.props.hideLoading();

                if (response.data.success) {
                    var logResponse = await this.props.getDonorCenterLogEntries(this.props.centerId, id, this.props.isSuperAdmin);

                    toast.success('Next follow-up date removed successfully');
                }
            });
        });
    }

    updateNextFollowUpDate = (id: number, date: string) => {
        this.props.showLoading('Changing next follow-up date, one moment please...').then(() => {
            this.props.updateNextFollowUpDate(this.props.centerId, id, date).then(async response => {
                this.props.hideLoading();

                if (response.data.success) {
                    var logResponse = await this.props.getDonorCenterLogEntries(this.props.centerId, id, this.props.isSuperAdmin);

                    toast.success('Next follow-up date changed successfully');
                }
            });
        });
    }

    handleCancelConfirmEmail = () => {
        this.setState({
            confirmView: {
                show: false,
                formData: null,
                jugArrivalDate: null
            }
        });
    }

    handleShowConfirmJugArrival = (id: number) => {
        let data = _.cloneDeep(this.state.donorRegistration);

        this.setState({
            confirmView: {
                show: true,
                formData: data,
                jugArrivalDate: moment().format('YYYY-MM-DD')
            }
        });
    }

    handleShowExpertSystemEnrollment = () => {
        let data = _.cloneDeep(this.state.donorRegistration);

        this.props.showLoading('Checking donor profile...').then(() => {
            this.props.checkDonorProfile(data.id)
                .then(response => {
                    const existingDonorAlias = response.data.success && response.data.results.exists
                        ? response.data.results.alias
                        : null;

                    this.setState({
                        confirmExpertSystemEnrollment: {
                            show: true,
                            formData: data,
                            error: '',
                            existingDonorAlias
                        }
                    });
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleCancelExpertSystemEnrollment = () => {
        this.setState({
            confirmExpertSystemEnrollment: {
                show: false,
                formData: null,
                error: '',
                existingDonorAlias: null
            }
        });
    }

    handleCancelExpertSystemResponse = () => {
        this.setState({
            confirmExpertSystemResponse: {
                show: false,
                donorId: -1,
                useBulkKit: null,
                existingTyping: false,
                existingRequestForTyping: false,
                alias: ''
            }
        });
    }

    handleConfirmEmail = () => {
        let data = _.cloneDeep(this.state.donorRegistration);

        this.setState({
            confirmView: {
                show: true,
                formData: data,
                jugArrivalDate: moment().format('YYYY-MM-DD')
            }
        });
    }

    handleMentorConfirm = () => {
        let data = _.cloneDeep(this.state.donorRegistration);

        this.setState({
            mentorConfirmView: {
                show: true,
                data
            }
        });
    }

    handleProcessExpertSystemEnrollment = (useBulkKit: number, alias: string, medicalRecordId: number) => {
        let registrationId = this.state.donorRegistration.id;

        this.props.showLoading('Enrolling Donor in Expert System, one moment please...').then(() => {
            this.props.enrollExpertSystem(registrationId, useBulkKit, alias, medicalRecordId)
                .then(response => {
                    if (response.data.success) {
                        let data = _.cloneDeep(this.state.donorRegistration)

                        if (data.id == registrationId) {
                            data.isExpertSystem = true;
                            data.isInExpertSystem = true;
                            data.isLinkedToDonor = true;
                        }

                        let { donorId, existingTyping, existingRequestForTyping, existingSwabMessage } = response.data.results;

                        this.setState({
                            donorRegistration: data,
                            confirmExpertSystemEnrollment: {
                                show: false,
                                formData: null,
                                error: '',
                                existingDonorAlias: null
                            },
                            confirmExpertSystemResponse: {
                                show: true,
                                donorId,
                                useBulkKit,
                                existingTyping,
                                existingRequestForTyping,
                                existingSwabMessage,
                                alias
                            }
                        });
                    } else {
                        let confirmExpertSystemEnrollment = _.cloneDeep(this.state.confirmExpertSystemEnrollment);
                        confirmExpertSystemEnrollment.error = response.data.message;

                        this.setState({
                            confirmExpertSystemEnrollment
                        });
                    }
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleDonorDetailsDownload = (id: number) => {
        this.props.showLoading('Downloading Donor Details, one moment please...').then(() => {
            this.props.donorDetailsPrint(this.props.centerId, id).then((response: any) => {
                downloadFile(response.data, `dcn-donor-details.pdf`, 'application/pdf');

                this.props.hideLoading();
            });
        });
    };

    handleLoginAs = (id: number) => {
        this.props.showLoading('Getting Login Link, one moment please...').then(() => {
            this.props.handleLoginAs(id).then((response: any) => {
                if( response.data.success )
                {
                    const loginUrl      = response.data.payload;
                    console.log(loginUrl);
                    debugger;
                    const newTab        = window.open(loginUrl, '_blank');

                    if( !newTab )
                    {
                        window.location.href = loginUrl;
                    }
                }
                else
                {
                    toast.error('Unable to get login link for donor.');
                }
            }).finally(() => {
                this.props.hideLoading();
            });
        });
    };

    handleGetLabResults = (id: number) => {
        this.props.showLoading('Getting lab results, one moment please...').then(() => {
            this.props.getLabResultsNotCombined(id)
                .then(response => {
                    downloadFile(response.data, 'lab-results.pdf', 'application/pdf');
                })
                .catch(() => {
                    toast.error('We are unable to get the lab results file.');
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        })
    }

    handleGetLabResultsCombined = (id: number) => {
        this.props.showLoading('Getting lab results, one moment please...').then(() => {
            this.props.getLabResultsCombined(id)
                .then(response => {
                    downloadFile(response.data, 'lab-results-combined.pdf', 'application/pdf');
                })
                .catch(() => {
                    toast.error('We are unable to get the lab results file.');
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        })
    }

    handleCancelMentorConfirm = () => {
        this.setState({
            mentorConfirmView: {
                show: false,
                data: null
            }
        });
    }

    handleArrivalDateChange = (arrivalDate: string) => {
        let confirmView = _.cloneDeep(this.state.confirmView);
        confirmView.jugArrivalDate = arrivalDate;

        this.setState({
            confirmView
        });
    }

    sendConfirmationEmail = () => {
        this.setState({
            confirmView: {
                show: true,
                formData: null,
                jugArrivalDate: moment().format('YYYY-MM-DD')
            }
        });
    }

    handleConfirmJugArrival = () => {
        let message = 'Updating Jug Information, one moment please...';

        this.props.showLoading(message).then(() => {
            let donorReg = this.state.confirmView.formData;
            let arrivalDate = this.state.confirmView.jugArrivalDate;

            this.props.markJugAsArrived(donorReg.id, arrivalDate)
                .then(response => {
                    this.setState({
                        confirmView: {
                            show: false,
                            formData: null,
                            jugArrivalDate: moment().format('YYYY-MM-DD')
                        }
                    });

                    toast.success('Jug marked as arrived. Email sent successfully.');
                })
                .catch((error: AxiosError) => {
                    toast.error('Unable to complete request: ' + error.response.data);
                })
                .finally(() => {
                    this.props.hideLoading();
                });
            ;
        });
    }

    handleSendEmail = (donoremailrequest: string) => {
        let message = 'Sending Email, one moment please...';

        this.setState({
            mentorConfirmView: {
                show: false,
                data: null
            }
        }, () => {
            this.props.showLoading(message).then(() => {
                let request: IDonorConnectEmailRequest = {
                    regId: this.props.regId,
                    centerId: this.props.centerId,
                    toEmail: donoremailrequest,
                    replyToEmail: '',
                    donorEmail: '',
                    emailSent: true,
                    emailSentDate: null,
                    subject: '',
                    content: ''
                }

                this.props.sendConfirmEmail(request)
                    .then(response => {
                        toast.success('Email sent successfully');
                    })
                    .catch((error: AxiosError) => {
                        toast.error('Unable to complete request: ' + error.response.data);
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        });
    }

    handleConfirmRuleOut = () => {
        this.setState({
            ruleOut: {
                show: true,
                data: this.state.donorRegistration
            }
        });
    }

    handleSubmitRuleOut = (isExpireRuleOut: number, isInEmr: number, disposition: number, ruleOutReasons: string) => {
        this.setState({
            ruleOut: {
                show: false,
                data: undefined
            }
        }, () => {
            this.props.showLoading('Updating record, one moment please...').then(() => {
                this.props.ruleOut(this.props.regId, isExpireRuleOut == 1, isInEmr == 1, disposition, ruleOutReasons)
                    .then(response => {
                        if (response.data.success) {
                            this.setState({
                                donorRegistration: response.data.results,
                            }, () => {
                                toast.success('Rule-out successful');
                            });
                        } else {
                            toast.error('Unable to rule-out the donor');
                        }
                    })
                    .catch((error) => {
                        toast.error('Unable to complete request: ' + error.response.data);
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        });
    }

    handleCancelRuleOut = () => {
        this.setState({
            ruleOut: {
                show: false,
                data: null
            }
        });
    }

    handleConfirmReverseRuleOut = () => {
        this.setState({
            reverseRuleOut: {
                show: true,
                data: this.state.donorRegistration
            }
        });
    }

    handleSubmitReverseRuleOut = () => {
        this.setState({
            reverseRuleOut: {
                show: false,
                data: undefined
            }
        }, () => {
            this.props.showLoading('Updating record, one moment please...').then(() => {
                this.props.reverseRuleOut(this.props.regId)
                    .then(response => {
                        if (response.data.success) {
                            this.setState({
                                donorRegistration: response.data.results,
                            }, () => {
                                toast.success('Reverse rule-out successful');
                            });
                        } else {
                            toast.error('Unable to reverse the rule-out of the donor');
                        }
                    })
                    .catch((error) => {
                        toast.error('Unable to complete request: ' + error.response.data);
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        });
    }

    handleCancelReverseRuleOut = () => {
        this.setState({
            reverseRuleOut: {
                show: false,
                data: null
            }
        });
    }

    handleShowTransferDonor = () => {
        let data = this.state.donorRegistration;
        let { recipientCenterId } = data;

        this.props.showLoading('Getting recipient coordinator list, one moment please...').then(() => {
            this.props.getRecipientCenterCoordList(recipientCenterId)
                .then(response => {
                    if (response.data.success) {
                        let { recipientCenterCoordinatorList } = response.data.results;

                        this.setState({
                            confirmTransferDonor: {
                                show: true,
                                formData: data,
                                coordinatorList: recipientCenterCoordinatorList,
                                coordinatorId: data.recipientCoordinatorId
                            }
                        }, () => {
                            this.props.hideLoading();
                        });
                    }
                })
                .catch((error: AxiosError) => {
                    this.props.hideLoading();
                });
        });
    }

    handleChangeCoordinator = (id: number) => {
        let updatedConfirmTransferDonor = {
            ...this.state.confirmTransferDonor,
            coordinatorId: id
        };

        this.setState({
            confirmTransferDonor: updatedConfirmTransferDonor
        }, () => {
            let { coordinatorIdValid } = this.validateRecipientCenterConfirm();

            this.setState({
                recipientCenterCoordValidation: {
                    coordinatorIdValid
                }
            });
        });
    };

    handleProceedTransferDonor = (id: number) => {
        let data = this.state.donorRegistration;
        let coordinatorId = this.state.confirmTransferDonor.coordinatorId;
        let { coordinatorIdValid } = this.validateRecipientCenterConfirm();

        this.setState({
            recipientCenterCoordValidation: {
                coordinatorIdValid
            }
        }, () => {
            let isValid = this.state.recipientCenterCoordValidation.coordinatorIdValid;

            if (isValid) {
                this.setState({
                    confirmTransferDonor: {
                        show: false,
                        formData: null,
                        coordinatorList: null,
                        coordinatorId: -1
                    }
                }, () => {

                    let { centerId, id: donorId, dashDomain, donorEditKey } = data;
                    this.props.showLoading('Redirecting to selecting a center, one moment please...').then(() => {
                        this.props.updateRecipientCenterCoord(centerId, id, coordinatorId)
                            .then(response => {
                                if (response.data.success) {
                                    window.location.href = `${dashDomain}/register/transfer-donor/${donorId}/${donorEditKey}`;
                                }
                            })
                            .finally(() => {
                                this.props.hideLoading();
                            });
                    });
                });
            }
        });
    }

    handleCancelShowTransferDonor = () => {
        this.setState({
            confirmTransferDonor: {
                show: false,
                formData: null,
                coordinatorList: null,
                coordinatorId: -1
            }
        });
    }

    handleGetLabOrders = () => {
        this.props.showLoading('Getting lab Orders, one moment please...').then(() => {
            this.props.getLabOrder(this.props.regId)
                .then(response => {
                    downloadFile(response.data, 'lab-order.pdf', 'application/pdf');
                })
                .catch(() => {
                    toast.error('We are unable to get the lab order file.');
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleShowConfirmExpireDonor = () => {
        this.setState({
            expireDonor: {
                show: true,
                data: this.state.donorRegistration
            }
        });
    }

    handleConfirmExpireDonor = () => {
        let { id, centerId } = this.state.expireDonor.data;

        this.setState({
            expireDonor: {
                show: false,
                data: null
            }
        }, () => {
            this.props.showLoading('Changing status, one moment please...').then(() => {
                this.props.expireDonor(id, centerId)
                    .then(response => {
                        if (response.data.success) {
                            this.setState({
                                donorRegistration: response.data.results,
                            }, () => {
                                toast.success('Status changed successfully');
                            });
                        }
                    })
                    .catch((error: AxiosError) => {
                        toast.error('Unable to complete request: ' + error.response.data);
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
                ;
            });
        });
    };

    handleCancelConfirmExpireDonor = () => {
        this.setState({
            expireDonor: {
                show: false,
                data: null
            }
        });
    }

    handleShowConfirmOptOutDonor = () => {
        this.setState({
            optOutDonor: {
                show: true,
                data: this.state.donorRegistration
            }
        });
    }

    handleConfirmOptOutDonor = () => {
        let { id, centerId } = this.state.optOutDonor.data;

        this.props.showLoading('Changing status, one moment please...').then(() => {
            this.props.optOutDonor(id, centerId)
                .then(response => {
                    if (response.data.success) {
                        this.handleCancelConfirmOptOutDonor();
                        toast.success('Status changed successfully.');
                    }
                })
                .catch((error: AxiosError) => {
                    toast.error('Unable to complete request: ' + error.response.data);
                })
                .finally(() => {
                    this.props.hideLoading();
                });
            ;
        });
    };

    handleCancelConfirmOptOutDonor = () => {
        this.setState({
            optOutDonor: {
                show: false,
                data: null
            }
        });
    }

    handleActionItemSelected = (id: number, action: number) => {
        if (action == DonorIntakeAction.ViewLabOrders) {
            this.handleGetLabOrders();
        }

        if (action == DonorIntakeAction.LabResults) {
            this.handleGetLabResults(id);
        }

        if (action == DonorIntakeAction.ViewLabResultsDataGenerated) {
            this.handleGetLabResultsCombined(id);
        }

        if (action == DonorIntakeAction.GetPdf) {
            this.handleDonorDetailsDownload(id);
        }

        if (action == DonorIntakeAction.CompleteForCandidate) {
            this.handleLoginAs(id);
        }

        if (action == DonorIntakeAction.ExpireDonor) {
            this.handleShowConfirmExpireDonor();
        }

        if (action == DonorIntakeAction.OptOutDonor) {
            this.handleShowConfirmOptOutDonor();
        }

        if (action == DonorIntakeAction.ConnectWithDonorMentor) {
            this.handleMentorConfirm();
        }

        if (action == DonorIntakeAction.RuleOut) {
            this.handleConfirmRuleOut();
        }

        if (action == DonorIntakeAction.ReverseRuleOut) {
            this.handleConfirmReverseRuleOut();
        }

        if (action == DonorIntakeAction.StartExpertSystem) {
            this.handleShowExpertSystemEnrollment();
        }

        if (action == DonorIntakeAction.ApplyForDonorShieldReimbursement) {
            this.handleApplyForDonorShield();
        }
    }

    handleApplyForDonorShield = () => {
        const donorRegistration = this.state.donorRegistration;

        if (!isEligibleForAdvancedReimbursementInvite(donorRegistration)) {
            toast.info('This donor already has a Donor Shield profile or is not eligible for Advanced Reimbursement.');
            return;
        }

        let data = _.cloneDeep(donorRegistration);
        data['donorShieldInvitePendingWorkup'] = true;
        this.setState({ donorRegistration: data }, () => {
        });
    }

    handleCloseDonorShieldInviteSent = () => {
        this.setState({
            donorShieldInviteSent: {
                show: false,
                donorName: ''
            }
        });
    }

    validateRecipientCenterConfirm = () => {
        let { confirmTransferDonor } = this.state;

        return {
            centerWorkFlowIdValid: true,
            centerNextFollowupDateValid: true,
            coordinatorIdValid: confirmTransferDonor.coordinatorId != -1 && confirmTransferDonor.coordinatorId != null
        };
    }

    render = () => {
        return (
            <>
                {this.state.donorRegistration != null && (
                    <Content
                        data={this.state.donorRegistration}
                        lookUpData={this.state.lookUpData}
                        statusFormBaselineKey={this.state.statusFormBaselineKey}
                        onDataChange={this.handleDataChange}
                        onUpdate={this.handleUpdate}
                        onSaveCenterCard={this.handleSaveCenterCard}
                        onSaveNetworkCard={this.handleSaveNetworkCard}
                        onItemSelected={this.handleActionItemSelected}
                        onRuleOut={this.handleStatusFormRuleOut}
                    />
                )}

                <MarkJugArrivedSendEmail
                    show={this.state.confirmView.show}
                    formData={this.state.confirmView.formData}
                    arrivalDate={this.state.confirmView.jugArrivalDate}
                    onDateChange={this.handleArrivalDateChange}
                    onConfirm={this.handleConfirmJugArrival}
                    onCancel={this.handleCancelConfirmEmail} />

                <RecipientCenterCoordinatorConfirm
                    show={this.state.confirmTransferDonor.show}
                    donorId={this.state.confirmTransferDonor.formData != null ? this.state.confirmTransferDonor.formData.id : 0}
                    coordinatorList={this.state.confirmTransferDonor.coordinatorList}
                    coordinatorId={this.state.confirmTransferDonor.coordinatorId}
                    validation={this.state.recipientCenterCoordValidation}
                    onCoordinatorChange={this.handleChangeCoordinator}
                    onConfirm={this.handleProceedTransferDonor}
                    onCancel={this.handleCancelShowTransferDonor} />

                <DonorConnectEmailConfirmation
                    container={null}
                    show={this.state.mentorConfirmView.show}
                    startingEmail={this.state.mentorConfirmView.data != null ? this.state.mentorConfirmView.data.email : ''}
                    onSendEmail={this.handleSendEmail}
                    onCancel={this.handleCancelMentorConfirm}
                />

                <ExpertSystemEnrollmentConfirm
                    show={this.state.confirmExpertSystemEnrollment.show}
                    centerId={this.props.centerId}
                    data={this.state.confirmExpertSystemEnrollment.formData}
                    error={this.state.confirmExpertSystemEnrollment.error}
                    existingDonorAlias={this.state.confirmExpertSystemEnrollment.existingDonorAlias}
                    onConfirm={this.handleProcessExpertSystemEnrollment}
                    onCancel={this.handleCancelExpertSystemEnrollment} />

                <ExpertSystemEnrollmentResponse
                    show={this.state.confirmExpertSystemResponse.show}
                    useBulkKit={this.state.confirmExpertSystemResponse.useBulkKit}
                    donorId={this.state.confirmExpertSystemResponse.donorId}
                    centerId={this.props.centerId}
                    existingTyping={this.state.confirmExpertSystemResponse.existingTyping}
                    existingRequestForTyping={this.state.confirmExpertSystemResponse.existingRequestForTyping}
                    existingSwabMessage={this.state.confirmExpertSystemResponse.existingSwabMessage}
                    alias={this.state.confirmExpertSystemResponse.alias}
                    onCancel={this.handleCancelExpertSystemResponse} />

                <RuleOut
                    show={this.state.ruleOut.show}
                    ruleOutReasons={this.state.lookUpData.ruleOutReasons}
                    onSubmit={this.handleSubmitRuleOut}
                    onCancel={this.handleCancelRuleOut} />

                <ExpireDonorModal
                    show={this.state.expireDonor.show}
                    fullName={this.state.expireDonor.data != null ? this.state.expireDonor.data.firstName + ' ' + this.state.expireDonor.data.lastName : ''}
                    onConfirm={this.handleConfirmExpireDonor}
                    onCancel={this.handleCancelConfirmExpireDonor} />

                <OptOutDonorModal
                    show={this.state.optOutDonor.show}
                    fullName={this.state.optOutDonor.data != null ? this.state.optOutDonor.data.firstName + ' ' + this.state.optOutDonor.data.lastName : ''}
                    onConfirm={this.handleConfirmOptOutDonor}
                    onCancel={this.handleCancelConfirmOptOutDonor} />

                <ReverseRuleOut
                    show={this.state.reverseRuleOut.show}
                    donor={this.state.reverseRuleOut.data}
                    onReverseRuleOut={this.handleSubmitReverseRuleOut}
                    onCancel={this.handleCancelReverseRuleOut} />

                {this.state.donorRegistration != null && (
                    <AdvancedReimbursementWorkupModal
                        show={this.state.advancedReimbursementWorkupModalOpen}
                        registration={this.state.donorRegistration}
                        milestone={Number(this.state.donorRegistration?.remoteStatus) === PRE_OP_SCHEDULED_REMOTE_STATUS_ID ? 'preop' : 'workup'}
                        onClose={this.handleAdvancedReimbursementWorkupModalClose}
                        onSaveWorkupWithoutInvite={this.handleAdvancedReimbursementSaveWorkupOnly}
                        onSaveWithAdvancedReimbursement={this.handleAdvancedReimbursementSubmitApply}
                        onSearchPerson={
                            Number(this.state.donorRegistration?.donationType) === DashDonationType.Liver
                                ? this.handleArDsdPersonSearch
                                : this.handleArDonorPersonSearch
                        }
                        onSearchAliases={
                            Number(this.state.donorRegistration?.donationType) === DashDonationType.Liver
                                ? this.handleArAliasSearch
                                : undefined
                        }
                    />
                )}

                {this.state.donorRegistration != null && (
                    <AdvancedReimbursementEnrolledScheduleModal
                        show={this.state.advancedReimbursementEnrolledScheduleModalOpen}
                        registration={this.state.donorRegistration}
                        onClose={this.handleAdvancedReimbursementEnrolledScheduleModalClose}
                        onConfirm={this.handleAdvancedReimbursementEnrolledScheduleConfirm}
                    />
                )}

                <DonorShieldInviteSentModal
                    show={this.state.donorShieldInviteSent.show}
                    donorName={this.state.donorShieldInviteSent.donorName}
                    onClose={this.handleCloseDonorShieldInviteSent}
                />
            </>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return ({
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        getDonorDetails: (centerId, regId) => {
            return dispatch(DashCenterActionCreators.getDonorDetails(centerId, regId));
        },
        donorDetailsPrint: (centerId, regId) => {
            return dispatch(DashCenterActionCreators.donorDetailsPrint(centerId, regId));
        },
        handleLoginAs: (registrationId) => {
            return dispatch(DashCenterActionCreators.handleLoginAs(registrationId));
        },
        updateDetails: (centerId, regId, wfStatusId, centerNextFollowUpDate, remoteStatus, onHoldStatusReason, remoteStatusDate, reviewComments) => {
            return dispatch(DashCenterActionCreators.updateDetails(centerId, regId, wfStatusId, centerNextFollowUpDate, remoteStatus, onHoldStatusReason, remoteStatusDate, reviewComments));
        },
        changeStatus: (request) => {
            return dispatch(DashCenterActionCreators.changeStatus(request));
        },
        updateDonorRegistrationWorkflowStatus: (centerId, regId, statusId, centerNextFollowUpDate) => {
            return dispatch(DashCenterActionCreators.updateDonorRegistrationWorkflowStatus(centerId, regId, statusId, centerNextFollowUpDate));
        },
        updateDonorRegistrationNetworkStatus: (centerId, regId, remoteStatus, remoteStatusDate, onHoldStatusReason, extras?: IAdvancedReimbursementNetworkPayload | null) => {
            return dispatch(DashCenterActionCreators.updateDonorRegistrationNetworkStatus(centerId, regId, remoteStatus, remoteStatusDate, onHoldStatusReason, extras));
        },
        searchArPerson: (centerId, firstName, lastName, birthDate, organType) => {
            return dispatch(DonorShieldDirectActionCreators.searchByPerson(centerId, firstName, lastName, birthDate, organType));
        },
        searchArAliases: (centerId, donorAlias, recipientAlias, organType) => {
            return dispatch(DonorShieldDirectActionCreators.searchByAliases(centerId, donorAlias, recipientAlias, organType));
        },
        searchArDonorPerson: (centerId, firstName, lastName, birthDate) => {
            return dispatch(DonorSearchActionCreators.searchByPerson(centerId, firstName, lastName, birthDate));
        },
        getDashCenterLookupData: (centerId, isSuper) => {
            return dispatch(DashCenterActionCreators.getDashCenterLookupData(centerId, isSuper));
        },
        getDonorCenterLogEntries: (centerId, regId, isAdmin) => {
            return dispatch(DashCenterActionCreators.getDashCenterLogEntries(centerId, regId, isAdmin));
        },
        updateDisposition: (id, detailRequest) => {
            return dispatch(DashCenterActionCreators.updateDisposition(id, detailRequest));
        },
        updateComments: (id, detailRequest) => {
            return dispatch(DashCenterActionCreators.updateComments(id, detailRequest));
        },
        saveLogEntry: (centerId, dashRegistrationId, actionTaken, comments) => {
            return dispatch(DashCenterActionCreators.saveLogEntry(centerId, dashRegistrationId, actionTaken, comments));
        },
        updateLogEntry: (id, centerId, dashRegistrationId, actionTaken, comments) => {
            return dispatch(DashCenterActionCreators.updateLogEntry(id, centerId, dashRegistrationId, actionTaken, comments));
        },
        deleteLogEntry: (centerId, dashRegistrationId, id) => {
            return dispatch(DashCenterActionCreators.deleteLogEntry(centerId, dashRegistrationId, id));
        },
        updateNextFollowUpDate: (centerId, registrationId, date) => {
            return dispatch(DashCenterActionCreators.updateNextFollowUpDate(centerId, registrationId, date));
        },
        changeAssignedCoordinator: (centerId, regId, contactId) => {
            return dispatch(DashCenterActionCreators.changeAssignedCoordinator(centerId, regId, contactId));
        },
        unassignCoordinator: (centerId, regId) => {
            return dispatch(DashCenterActionCreators.unassignCoordinator(centerId, regId));
        },
        updateDonorDetails: (id, detailRequest) => {
            return dispatch(DashCenterActionCreators.updateDonorDetails(id, detailRequest));
        },
        enrollExpertSystem: (registrationId, bulkType, alias, medicalRecordId) => {
            return dispatch(DashCenterActionCreators.enrollExpertSystem(registrationId, bulkType, alias, medicalRecordId));
        },
        checkDonorProfile: (registrationId) => {
            return dispatch(DashCenterActionCreators.checkDonorProfile(registrationId));
        },
        getLabResultsNotCombined: (registrationId) => {
            return dispatch(DashCenterActionCreators.getLabResultsNotCombined(registrationId));
        },
        getLabResultsCombined: (registrationId) => {
            return dispatch(DashCenterActionCreators.getLabResultsCombined(registrationId));
        },
        sendConfirmEmail: (request) => {
            return dispatch(DashCenterActionCreators.sendConfirmEmail(request));
        },
        markJugAsArrived: (donorId, arrivalDate) => {
            return dispatch(DashCenterActionCreators.markJugAsArrived(donorId, arrivalDate));
        },
        ruleOut: (registrationId, isExpireRuleOut, isInEmr, disposition, ruleOutReasons) => {
            return dispatch(DashCenterActionCreators.ruleOut(registrationId, isExpireRuleOut, isInEmr, disposition, ruleOutReasons));
        },
        reverseRuleOut: (registrationId) => {
            return dispatch(DashCenterActionCreators.reverseRuleOut(registrationId));
        },
        validateExpertSystemEnrollment: (registrationId, alias) => {
            return dispatch(DashCenterActionCreators.validateExpertSystemEnrollment(registrationId, alias));
        },
        getRecipientCenterCoordList: (centerId) => {
            return dispatch(DashCenterActionCreators.getRecipientCenterCoordList(centerId));
        },
        updateRecipientCenterCoord: (centerId, donorId, coordinatorId) => {
            return dispatch(DashCenterActionCreators.updateRecipientCenterCoord(centerId, donorId, coordinatorId));
        },
        getLabOrder: (registrationId) => {
            return dispatch(DashCenterActionCreators.getLabOrder(registrationId));
        },
        expireDonor: (registrationId, centerId) => {
            return dispatch(DashCenterActionCreators.expireDonor(registrationId, centerId));
        },
        optOutDonor: (registrationId, centerId) => {
            return dispatch(DashCenterActionCreators.optOutDonor(registrationId, centerId));
        }
    });
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(DonorDetails);

